<template>
  <MatchMarkers :markers="match.markers" />

  <AudioMatch
    v-for="variant in variants"
    :key="variant"
    :match="props.match"
    :variant="variant"
    :number="number"
    :allow-playback="canPlayMatch"
  />
</template>

<script setup lang="ts">
import {
  type FragmentType,
  useFragment,
} from '@/shared/graphql/router/fragment-masking'
import AudioMatch, { AudioMatchFragment } from './AudioMatch.vue'
import MatchMarkers from './MatchMarkers.vue'
import { computed } from 'vue'

const props = defineProps<{
  match: FragmentType<typeof AudioMatchFragment>
  number: number
  side?: 'registered' | 'infringing'
  allowPlayback?: boolean
}>()

const match = useFragment(AudioMatchFragment, props.match)
const variants = ['original', 'stem'] as const
const canPlayMatch = computed(() => props.allowPlayback !== false)
</script>
